import type { DeadlineTemplateResult } from '../app/data/content/DeadlineTemplateFragment'

export const isDeadlineEnabled = (deadlineTemplate?: DeadlineTemplateResult) =>
	deadlineTemplate?.cutoff !== 0 || deadlineTemplate?.period !== 0
